import { get } from 'lodash'
import activeAward from '../../helpers/activeAward'
import { CONFIGURATION_KEYS } from '../../constants/enums'


export const asyncValidate = (val, dispatch, props) => {
    const { values } = props

    const orgId = get(props, `participants.detail.awards[${activeAward(get(props, 'participants.detail'))}].organization.id`) || get(props, 'activeOrganization.id')

    const manageAssessorsSetting = get(props.configuration, `valuesByOrganizationId[${orgId}][${CONFIGURATION_KEYS.manageAssessors.id}]`)

    const isAssessorManagementEnabled = get(manageAssessorsSetting, 'booleanValue')

    if (!isAssessorManagementEnabled) {
        return new Promise(resolve => resolve())
    }

    const isPerson = get(props, 'form') === 'leaderDetail'

    const defaultResponse = { body: { value: false } }

    const pid = isPerson ? get(values, 'person.id') : get(values, 'id')

    const email = isPerson ? get(values, 'person.email') : get(values, 'email')

    const secondaryEmail = isPerson ? get(values, 'person.secondaryEmail') : get(values, 'secondaryEmail')

    const tertiaryEmail = isPerson ? get(values, 'person.tertiaryEmail') : get(values, 'tertiaryEmail')

    let calls = []

    if(secondaryEmail){
        calls.push(props.checkEmail({ email: secondaryEmail, personId: pid, checkAlternativeEmails: true }).catch(() => defaultResponse))
    }

    if(tertiaryEmail){
        props.checkEmail({ email: tertiaryEmail, personId: pid, checkAlternativeEmails: true }).catch(() => defaultResponse)
    }

    const promises = Promise.all(calls)
    const EMAIL_IN_USE = {
        text: 'E-mail address is already in use.',
        intlKey: 'errors.email_address_is_in_use'
    }

    const SAME_EMAILS = {
        text: 'E-mail cannot be the same.',
        intlKey: 'errors.emails_cannot_be_same'
    }

    return promises
        .then(r => {
            const [secondaryEmailRes, tertiaryEmailRes] = r
            const errors = {}
            errors['person.secondaryEmail'] = get(secondaryEmailRes, 'body.value') ? EMAIL_IN_USE : undefined
            errors['person.tertiaryEmail'] = get(tertiaryEmailRes, 'body.value') ? EMAIL_IN_USE : undefined

            const errors2 = {
                secondaryEmail: get(secondaryEmailRes, 'body.value') ? EMAIL_IN_USE : undefined,
                tertiaryEmail: get(tertiaryEmailRes, 'body.value') ? EMAIL_IN_USE : undefined,
            }

            if (tertiaryEmail && (email === tertiaryEmail || (secondaryEmail && tertiaryEmail && secondaryEmail === tertiaryEmail))) {
                // eslint-disable-next-line
                const err = { person: { 'tertiaryEmail': SAME_EMAILS}}
                throw isPerson ? err : { tertiaryEmail: SAME_EMAILS }
            }

            if (secondaryEmail && (email === secondaryEmail || (tertiaryEmail && secondaryEmail && tertiaryEmail === secondaryEmail))) {
                // eslint-disable-next-line
                const err = { person: { 'secondaryEmail': SAME_EMAILS}}
                throw isPerson ? err : { secondaryEmail: SAME_EMAILS }
            }

            if (Object.values(errors).some(v => v)) {
                throw isPerson ? errors : errors2
            }
        })
}
